export { FlexibleImage, type FlexibleImageProps } from "./FlexibleImage";
